import { isProdOrTestnet, isTestnet } from '@bfe/by-env';

import { supportLanguages } from '@/utils/common/lanauges';
const bybitLangObj = {} as Record<string, string>;

export const i18nCache = {
  setLocaleMessage: (lang: string, msg: any) => {
    console.log('msg in i18n:', msg);
  },
  locale: 'en',
  getAntdLocale: (lang: string) => {
    setI18nLanguage(lang);
    if (bybitLangObj[lang]) return bybitLangObj[lang];

    supportLanguages.forEach((item: any) => {
      bybitLangObj[item] = item.split('-').join('_');
    });
    console.log('bybitLangObj=', bybitLangObj);
    return bybitLangObj[lang];
  },

  i18n: {
    changeLanguage: (lang: string) => {
      console.log('init changeLanguage lang:', lang);
    },
  },

  async dynamicGetAntDLocaleEnUS() {
    return (await import('antd/lib/locale/en_US')).default;
  },

  async dynamicGetAntDLocaleEsES() {
    return (await import('antd/lib/locale/es_ES')).default;
  },

  async dynamicGetAntDLocaleFrFR() {
    return (await import('antd/lib/locale/fr_FR')).default;
  },

  async dynamicGetAntDLocaleHiIN() {
    return (await import('antd/lib/locale/hi_IN')).default;
  },

  async dynamicGetAntDLocaleIdID() {
    return (await import('antd/lib/locale/id_ID')).default;
  },

  async dynamicGetAntDLocaleJaJP() {
    return (await import('antd/lib/locale/ja_JP')).default;
  },

  async dynamicGetAntDLocaleKkKZ() {
    return (await import('antd/lib/locale/kk_KZ')).default;
  },

  async dynamicGetAntDLocalePtBR() {
    return (await import('antd/lib/locale/pt_BR')).default;
  },

  async dynamicGetAntDLocaleRuRU() {
    return (await import('antd/lib/locale/ru_RU')).default;
  },

  async dynamicGetAntDLocaleThTH() {
    return (await import('antd/lib/locale/th_TH')).default;
  },

  async dynamicGetAntDLocaleTrTR() {
    return (await import('antd/lib/locale/tr_TR')).default;
  },

  async dynamicGetAntDLocaleUkUA() {
    return (await import('antd/lib/locale/uk_UA')).default;
  },

  async dynamicGetAntDLocaleViVN() {
    return (await import('antd/lib/locale/vi_VN')).default;
  },

  async dynamicGetAntDLocaleZhCN() {
    return (await import('antd/lib/locale/zh_CN')).default;
  },

  async dynamicGetAntDLocaleZhTW() {
    return (await import('antd/lib/locale/zh_TW')).default;
  },
  // 荷兰
  async dynamicGetAntDLocaleNlNL() {
    return (await import('antd/lib/locale/nl_NL')).default;
  },
  // 意大利
  async dynamicGetAntDLocaleItIT() {
    return (await import('antd/lib/locale/it_IT')).default;
  },
  // 波兰
  async dynamicGetAntDLocalePlPL() {
    return (await import('antd/lib/locale/pl_PL')).default;
  },
};

export const i18nUrl = (lng: string[], namespaces: string[]) => {
  // s1主网，t1testnet
  // let url =
  //   'https://tms.ffe390afd658c19dcbf707e0597b846d.de/download/trade/{{ns}}/{{lng}}/'; // 测试

  let url = '';

  const testnetAndProdUrl = `/common-static/fhs/i18n-upload/low-cache/project/release/{{ns}}/${
    isTestnet ? 'testnet-' : ''
  }{{lng}}.json?v=1`;
  const devAndTestUrl =
    'https://fh-static.bycsi.com/i18n-upload/low-cache/project/release/{{ns}}/test-{{lng}}.json?v=1';
  url = !isProdOrTestnet ? devAndTestUrl : testnetAndProdUrl;
  if (namespaces.includes('inverse')) {
    url = url.replace('{{ns}}', 'user-service-nextjs');
    console.log('namespaces', namespaces.includes('inverse'), url);
  }

  return url;
};

function setI18nLanguage(lang: string) {
  i18nCache.locale = lang;
  (document.querySelector('html') as HTMLElement).setAttribute('lang', lang);
  return lang;
}
